module.exports = __webpack_public_path__ + "img/hkqaa.7080cbdd.png";